import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { ViewFieldsFragment } from '@salescore/client-api'
import type { CompiledFormViewConfig, ViewUICol } from '@salescore/core'
import { Col } from 'antd'
import { type ReactElement, useContext } from 'react'

import type { SalescoreObjectAbility, ViewAbility } from '../../recoil/view/atoms'
import { ViewUIContext, ViewUIFormComponentC } from './ViewUIComponent'

export const ViewUIColC = ({
  component,
  compiledConfig,
  showError,
  view,
  ability,
}: {
  component: ViewUICol
  compiledConfig: CompiledFormViewConfig
  showError: boolean
  view: ViewFieldsFragment
  ability: ViewAbility & SalescoreObjectAbility
}): ReactElement => {
  const { isEditMode } = useContext(ViewUIContext)
  const { attributes, listeners, setNodeRef, transform, isDragging } = useSortable({ id: component.id })

  if (isEditMode) {
    return (
      <Col
        key={component.id}
        span={component.span}
        className={
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          isEditMode ? `border border-solid border-gray-100 p-1` : ``
        }
        ref={setNodeRef}
        style={{
          transform: CSS.Transform.toString(transform),
          transition: isDragging ? 'boxShadow 100ms ease' : 'all 200ms ease',
          // transition,
          cursor: isDragging ? 'grabbing' : 'grab',
          zIndex: isDragging ? 1000 : 0,
          backgroundColor: 'white',
          boxShadow: isDragging ? '-1px 0 15px 5px rgba(34, 33, 81, 0.1)' : '',
        }}
        {...attributes}
        {...listeners}
      >
        {component.children.map((child, index) => (
          <ViewUIFormComponentC
            key={`${child.type}_${index}`}
            component={child}
            compiledConfig={compiledConfig}
            showError={showError}
            view={view}
            ability={ability}
          />
        ))}
      </Col>
    )
  }

  return (
    <Col key={component.id} span={component.span}>
      {component.children.map((child, index) => (
        <ViewUIFormComponentC
          key={`${child.type}_${index}`}
          component={child}
          compiledConfig={compiledConfig}
          showError={showError}
          view={view}
          ability={ability}
        />
      ))}
    </Col>
  )
}
